import * as React from "react"
import PowerIcon from "../../atoms/icons/PowerIcon"
import SettingsOverviewCard from "../../molecules/SettingsOverviewCard"
import ReadOnlyTextField from "../../molecules/card/ReadOnlyTextField"
import { useEdgeApi } from "../../../edge/EdgeProvider"
import { VOLTAGE_FLOAT_DECIMAL_COUNT } from "../../constants"
import { SECTION_SYSTEM_PWB_METRICS } from "../../../utils/pages"

const PwbVoltagesCard: React.FunctionComponent = () => {
  const { metrics } = useEdgeApi()

  const displayVoltage = (voltage?: number) =>
    voltage ? `${voltage.toFixed(VOLTAGE_FLOAT_DECIMAL_COUNT)} V` : undefined

  const displayCurrent = (current?: number) =>
    current ? `${current.toFixed(VOLTAGE_FLOAT_DECIMAL_COUNT)} A` : undefined

  return (
    <SettingsOverviewCard title={SECTION_SYSTEM_PWB_METRICS.name} icon={<PowerIcon />}>
      <ReadOnlyTextField placeholder="-.- V" label="48V supply" value={displayVoltage(metrics.usePwbMetricsPow48v())} />
      <ReadOnlyTextField
        placeholder="-.- V"
        label="3.3V supply"
        value={displayVoltage(metrics.usePwbMetricsPow3v3())}
      />
      <ReadOnlyTextField
        placeholder="-.- A"
        label="Current sense"
        value={displayCurrent(metrics.usePwbMetricsCurrentSense())}
      />
      <ReadOnlyTextField
        placeholder="-.-"
        label="Enable Output"
        value={metrics.usePwbMetricsEnableOutput() ? "Yes" : "No"}
      />
      <ReadOnlyTextField
        placeholder="-.-"
        label="Button pressed"
        value={metrics.usePwbMetricsButtonPressed() ? "Yes" : "No"}
      />
      <ReadOnlyTextField placeholder="-.-" label="Fault detected" value={metrics.usePwbMetricsFault() ? "Yes" : "No"} />
    </SettingsOverviewCard>
  )
}

export default PwbVoltagesCard
